import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon, getUtility, ExpandedTooltip, InputWithIcon, BackdropLoader, toast } from '@livable/saas-react-components';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { Button, Typography, ToggleButtonGroup, ToggleButton, Grid, TextField } from '@mui/material';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
import { isValueNumber } from 'src/utils/typeValidators';
export default function AllocationMethodModal(_ref) {
  var _store$homeDashboardS, _store$homeDashboardS2, _store$properties$upd, _store$homeDashboardS7, _store$properties$upd2, _store$homeDashboardS0;
  let propertyUtility = _ref.propertyUtility,
    billingMethod = _ref.billingMethod;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  const _useState3 = useState((_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.propertyBuildingSquare),
    _useState4 = _slicedToArray(_useState3, 2),
    initSqFootage = _useState4[0],
    setInitSqFootage = _useState4[1];
  const _useState5 = useState((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.propertyBuildingSquare),
    _useState6 = _slicedToArray(_useState5, 2),
    localBuildingSquareData = _useState6[0],
    setLocalBuildingSquareData = _useState6[1];
  const _useState7 = useState(propertyUtility.allocationMethod),
    _useState8 = _slicedToArray(_useState7, 2),
    initAllocationMethod = _useState8[0],
    setInitAllocationMethod = _useState8[1];
  const _useState9 = useState(propertyUtility.allocationMethod),
    _useState0 = _slicedToArray(_useState9, 2),
    allocationMethod = _useState0[0],
    setAllocationMethod = _useState0[1];
  const handleAllocationMethodChange = (e, value) => {
    if (value) setAllocationMethod(value);
  };
  useEffect(() => {
    if (billingMethod === 'SubMeter') {
      setAllocationMethod(ALLOCATION_METHOD.BySubmeter);
    }
  }, [billingMethod]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getWarning = isProviderName => /*#__PURE__*/React.createElement("div", {
    className: classes.warning
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "warning",
    title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "white"
    }, t('add_new_property_flow.reminder')), isProviderName ? t('add_new_property_flow.enter_provider_name') : t('add_new_property_flow.enter_utility_name')),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    type: "warning",
    fontSize: isProviderName ? 'small' : '',
    state: "warning"
  }))));
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, getUtility(propertyUtility.utilityName).icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getUtility(propertyUtility.utilityName).title, " ", t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.allocation_method_modal')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, propertyUtility.provider.utilityProviderName);
  const BuildingSquareInternal = _ref2 => {
    let isBySquareFootage = _ref2.isBySquareFootage;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.property_square_footage'))), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "Property square footage is required for allocation method '", isBySquareFootage ? 'Square footage' : '50%Occupancy/50%Square Footage', "'. Please fill in a field below.")), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      rowSpacing: 24,
      columnSpacing: 10
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "building"
      })
    }, /*#__PURE__*/React.createElement(TextField, {
      label: t('general.square_ft'),
      variant: "outlined",
      fullWidth: true,
      autoFocus: true,
      type: "text",
      id: "buildingSquare",
      name: "buildingSquare",
      value: localBuildingSquareData,
      onKeyPress: event => {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
      },
      onChange: event => {
        event.preventDefault();
        if (!/^[1-9][0-9]*$|^$/.test(event.target.value)) return;
        setLocalBuildingSquareData(event.target.value);
      },
      error: Number(localBuildingSquareData) === 0
    }))))));
  };
  const updatePropertySqFootage = async () => {
    var _store$homeDashboardS3, _store$homeDashboardS4, _store$homeDashboardS5, _store$homeDashboardS6;
    return store.properties.updatePropertyAsync.run({
      updateStore: false,
      propertyId: (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.id,
      buildings: [{
        buildingId: (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.propertyBuildingId,
        buildingSquare: Number(localBuildingSquareData) !== Number((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.propertyBuildingSquare) && isValueNumber(localBuildingSquareData) && Number(localBuildingSquareData)
      }]
    }, [(_store$homeDashboardS6 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.propertyBuildingId]);
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      onClick: () => {
        setModalState(true);
      },
      'custom-attribute': '619-new-billing-module'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('general.edit')))
    // disabledTrigger={disabledTrigger}
    ,
    title: modalTitle,
    subTitle: modalSubTitle,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      disabled: (allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage || allocationMethod === ALLOCATION_METHOD.BySquareFootage) && Number(localBuildingSquareData) === 0 || ((_store$properties$upd = store.properties.updatePropertyAsync) === null || _store$properties$upd === void 0 || (_store$properties$upd = _store$properties$upd.inProgressUnicIds) === null || _store$properties$upd === void 0 ? void 0 : _store$properties$upd.includes((_store$homeDashboardS7 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.propertyBuildingId)),
      onClick: async e => {
        e === null || e === void 0 || e.preventDefault();
        setInitAllocationMethod(allocationMethod);
        setInitSqFootage(localBuildingSquareData);
        propertyUtility.setAllocationMethod(allocationMethod);
        if (allocationMethod === ALLOCATION_METHOD.BySquareFootage || allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) {
          var _store$homeDashboardS8;
          if (Number(localBuildingSquareData) !== Number((_store$homeDashboardS8 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.propertyBuildingSquare)) {
            const resUpdateSqFootage = await updatePropertySqFootage();
            if (resUpdateSqFootage !== null && resUpdateSqFootage !== void 0 && resUpdateSqFootage.isSuccessful) {
              var _store$homeDashboardS9;
              toast('success', {
                body: ['Property Square footage updated']
              });
              (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS9 === void 0 || _store$homeDashboardS9.setPropertyBuildingSquare(localBuildingSquareData);
            }
          }
        }
        setModalState(false);
      },
      'custom-attribute': '620-new-billing-module'
    }, t('add_new_property_flow.save_and_close')),
    noLeftButton: true,
    variant: "staticHeightLarge",
    isOpen: modalState,
    handleOpen: () => setModalState(true),
    handleClose: () => {
      setAllocationMethod(initAllocationMethod || propertyUtility.allocationMethod);
      setLocalBuildingSquareData(initSqFootage);
      setModalState(false);
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.allocation_method_by')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: allocationMethod,
    onChange: handleAllocationMethodChange,
    exclusive: true,
    orientation: "vertical",
    fullWidth: true,
    className: classes.allocationMethodGroup,
    'custom-attribute': '621-new-billing-module'
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByOccupancy,
    'custom-attribute': '622-new-billing-module-ByOccupancy'
  }, t('general.occupancy')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.BySquareFootage,
    'custom-attribute': '622-new-billing-module-BySquareFootage'
  }, t('general.square_footage')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByUnit,
    'custom-attribute': '622-new-billing-module-ByUnit'
  }, t('general.unit')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByPercentageShare,
    'custom-attribute': '622-new-billing-module-ByPercentageShare'
  }, t('By Percentage Share')), store.account.featureFlagsStore.getIsSubmeterInterimSolutionEnabled || billingMethod === 'SubMeter' ? /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.BySubmeter,
    'custom-attribute': '622-new-billing-module-BySubmeter'
  }, t('general.by_submeter')) : null, /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.By50Occupancy50SquareFootage,
    'custom-attribute': '622-new-billing-module-By50Occupancy50SquareFootage'
  }, t('By 50%Occupancy/50%Square Footage')), store.company.companyFeatureStore.enableAllocationByNumberOfOccupants ? /*#__PURE__*/React.createElement(ToggleButton, {
    value: ALLOCATION_METHOD.ByNumberOfOccupants,
    'custom-attribute': '622-new-billing-module-ByNumberOfOccupants'
  }, t('add_new_property_flow.allocation_method_number_of_occupants')) : null)), (allocationMethod === ALLOCATION_METHOD.BySquareFootage || allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage) && /*#__PURE__*/React.createElement(BuildingSquareInternal, {
    isBySquareFootage: allocationMethod === ALLOCATION_METHOD.BySquareFootage
  }), allocationMethod === ALLOCATION_METHOD.ByOccupancy && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.allocation_method_hint'))), allocationMethod === ALLOCATION_METHOD.ByNumberOfOccupants && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.allocation_method_number_of_occupants_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(HelpCenterButton, null)), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: (_store$properties$upd2 = store.properties.updatePropertyAsync) === null || _store$properties$upd2 === void 0 || (_store$properties$upd2 = _store$properties$upd2.inProgressUnicIds) === null || _store$properties$upd2 === void 0 ? void 0 : _store$properties$upd2.includes((_store$homeDashboardS0 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.propertyBuildingId)
  }));
}